import React, { Fragment, useState } from 'react';
import { useEffect } from 'react';
import { openModal}  from '../api/zendesk'
import { isoToBrDate } from '../utils';
import * as vtex from '../api/vtex'
import './Table.css';

export default function Table() {
  const [searchQuery, setSearchQuery] = useState('')
  const [orders, setOrders] = useState([])

  async function loadOrders(query, shoeIncomplete = false) {
    const resp = await vtex.getOrders(query, shoeIncomplete) 
    if (query === '') {
      setOrders(null)
    }
    else {
      setOrders(resp.list)
    }
  }

  function preventEnter(e) {
    const enter = 13
    if (e.keyCode === enter)
      e.preventDefault()
  }

  async function handleOrderClick(order) {
    openModal('modal', { width: '80vw', height: '80vh' }, order.orderId)
  }

  function Troca(e) {
    loadOrders(searchQuery, e.target.checked)
  }

  useEffect(() => {
    const timer = setTimeout(() => loadOrders(searchQuery), 1000)
    return () => clearInterval(timer)
  }, [searchQuery])

  return (
    <div className="Table">
      <div className="image">
        <img className="logo-table" alt="Logo da Vtex" src="https://upload.wikimedia.org/wikipedia/commons/a/a9/VTEX_Logo.svg" />
        <div className="switch__container">
          <input onClick={Troca} id="switch-shadow" class="switch switch--shadow" type="checkbox" />
          <label for="switch-shadow"></label>
          <i class="fa fa-arrow-left" aria-hidden="true"></i>

        </div>
        <span className="msgbtn-incompleteOrders">
<strong>Clique aqui para consultar por</strong> <br/><strong>
Não faturados/ Incompletos</strong></span>
      </div>
      <form>
        <input className="search-table" type="text" placeholder="Buscar por Número do Pedido/ CPF / Id do cliente"
          value={searchQuery} onChange={e => setSearchQuery(e.target.value)} onKeyDown={preventEnter} />
      </form>
      <div className="historic-pedidos">
        <div className="containerTable">
          <div className="headerTable">
            <span>Pedidos</span>
            <span>Nome</span>
            <span>Data</span>
            <span>Status</span>
            <span>Valor</span>
          </div>

          <div className="tableInforms">
            {orders?.map(item => <Fragment>
              <div className="tableLine">
                <span>{item.sequence}</span>
                <span>{item.clientName}</span>
                <span>{isoToBrDate(item.creationDate)}</span>
                <span>{item.statusDescription}</span>
                <span>{item.totalValue /100 +',00'}</span>
                <button className="buttonShowDetails" onClick={() => handleOrderClick(item)}><i class="fas fa-eye"></i></button>
              </div>
            </Fragment>)}
          </div>
        </div>
      </div>
    </div>
  )
}